import React from 'react';

import './ContactTitle.css'

export function CTTitle(props: {
    children: JSX.Element | Array<JSX.Element> | string
}) {
    return (
        <div className='contact-title-title'>
            {props.children}
        </div>
    )
}

export function CTText(props: {
    children: JSX.Element | Array<JSX.Element> | string
}) {
    return (
        <div className='contact-title-text'>
            {props.children}
        </div>
    )
}

export function CTIcon(props: {
    src: string
    alt?: string
}) {
    return (
        <div className='contact-title-icon-bg'>
            <img className="contact-title-icon" src={props.src} alt={props.alt}/>
        </div>
    )
}


export default function ContactTitle(props: {
    src: string,
    alt?: string
    children?: JSX.Element | Array<JSX.Element> | string
}) {
    return (
        <div className='contact-title'>
            <CTIcon src={props.src} alt={props.alt}/>
            {props.children}
        </div>
    )
}